import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import { ScheduledTime } from "model";

/**
* @class QuietTime
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.quietTimes[0];
* const contactInfo = new QuietTime(record);
* @property {NUMBER} _id - The id of the quietTime.
* @property {STRING} _type - A type indicating "sms" or "e-mail" for now.
* @property {STRING} _typeFormatted - A formatted type indicating "sms" or "e-mail" for now.
* @property {BOOLEAN} _isEnabled - The on/off value of the quick time, set by the user.
* @property {ARRAY} _weekdayIDs - An array of weekday ids set by the user.
* @property {ScheduledTime} _startScheduledTime - The "start" scheduled time.
* @property {ScheduledTime} _endScheduledTime - The "end" scheduled time.
*/
export default class QuietTime extends BCMSRecord {
    _id
    _type
    _typeFormatted
    _isEnabled
    _weekdayIDs
    _startScheduledTime
    _endScheduledTime

    constructor (record){     
      super(record) 
    }
  }
  QuietTime.define({
    "recordType":"quietTimes",
    "recordIDProp":"id",
    "className" : "QuietTime",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the QuietTime
       * @property set {NUMBER} - sets the id of the QuietTime
       * @memberof QuietTime
       */
      BCMSRecordProperty.mapToString("id", "_id"),

      /** 
       * @name type
       * @instance
       * @property get {NUMBER} - gets the type of the QuietTime
       * @property set {NUMBER} - sets the type of the QuietTime
       * @memberof QuietTime
       */
      BCMSRecordProperty.mapToString("type", "_type"),

      /** 
       * @name typeFormatted
       * @instance
       * @property get {NUMBER} - gets the typeFormatted of the QuietTime
       * @property set {NUMBER} - sets the typeFormatted of the QuietTime
       * @memberof QuietTime
       */
      BCMSRecordProperty.mapToString("typeFormatted", "_typeFormatted"),

      /** 
       * @name isEnabled
       * @instance
       * @property get {NUMBER} - gets the id of the QuietTime
       * @property set {NUMBER} - sets the id of the QuietTime
       * @memberof QuietTime
       */
      BCMSRecordProperty.mapToBoolean("isEnabled", "_isEnabled"),

      /** 
       * @name startScheduledTime
       * @instance
       * @property get {STRING} - gets the value of the startScheduledTime
       * @property set {STRING} - sets the value of the startScheduledTime
       * @memberof ScheduledAlert
       */
      BCMSRecordProperty.mapToClass("startScheduledTime", "_startScheduledTime", () => ScheduledTime),

      /** 
       * @name endScheduledTime
       * @instance
       * @property get {STRING} - gets the value of the endScheduledTime
       * @property set {STRING} - sets the value of the endScheduledTime
       * @memberof ScheduledAlert
       */
      BCMSRecordProperty.mapToClass("endScheduledTime", "_endScheduledTime", () => ScheduledTime),

        /**
         * @name weekdayIDs
         * @instance
         * @property get {ARRAY} - gets the weekdayIDs of notification detail
         * @property set {ARRAY} - sets the weekdayIDs of notification detail
         * @note The mapToArray currently does not work correctly when the toRecord function is called
         * @memberof QuietTime
         */
        BCMSRecordProperty.mapTo({
            id: "weekdayIDs",
            instanceField: "_weekdayIDs",
            setter: function(value) {
                this._weekdayIDs = value === undefined || Array.isArray(value)
                    ? value : value.split(",");
            },
            toRecord: function() {
                return this._weekdayIDs === undefined || this._weekdayIDs.length === 0
                    ? ""
                    : this._weekdayIDs.reduce((result, item) => `${ result },${ item }`);
            }
        })
    ]  
})




